export default __webpack_public_path__ + "static/media/40k.07b1f0c8.md";